import moment from 'moment'
import {
  UserDetail,
  RoleData,
  EditingRoleData,
  UserForm,
} from '../../../../../models'
import { AppPermission } from '../../../../../models/Permission'
import { PrintingPolicyData } from '../../../../../models/Printing'

export const INIT_USER: UserDetail = {
  active: true,
  code: '',
  id: '',
  mail: '',
  name: '',
  pre_name: '',
  roles: [],
  created_at: 0,
  updated_at: 0,
  views: [],
}

export const INIT_FORM: UserForm = {
  nom: '',
  pre_nom: '',
  mail: '',
  actif: true,
  role: '',
  code: '',
  password: '',
}

export const INIT_SELECTED_ROLE_DATA: EditingRoleData = {
  client: '',
  company: '',
  warehouse: '',
  client_id: '',
  company_id: '',
  warehouse_id: '',
  description: '',
}

export const INIT_PRINTING_POLICY: PrintingPolicyData = {
  id: '',
  warehouse: '',
  warehouse_id: '',
  printer: {
    id: '',
    name: '',
    ip: '',
    label: '',
    value: '',
    status: '',
  },
  code: '',
  printer_id: '',
  user_id: '',
  policy_type: '',
  detailed_policies: {
    media: undefined,
    tray: undefined,
    documents: [],
  },
  created_at: 0,
  updated_at: 0
}

export const INIT_ROLE_DATA: RoleData = {
  id: '',
  client: '',
  company: '',
  warehouse: '',
  updatedAt: moment().unix(),
  description: '',
  client_id: '',
  company_id: '',
  warehouse_id: '',
  role_template_id: '',
  canEdit: true,
  isEditing: true,
  hasError: false,
  is_original_permission: true,
}

export enum Entity {
  Dashboard = 'dashboard',
  Stock = 'stock',
  Attendu = 'attendu',
  Commande = 'commande',
  Mission = 'mission',
}

export enum Permission {
  ReadStock = 'read_stock',
  ReadPersonel = 'read_personel',
  ReadWarehouse = 'read_warehouse',
  Update = 'update',
  Create = 'create',
  Read = 'read',
  Delete = 'delete',
  UpsertStock = 'upsert_stock',
  UpsertAttendu = 'upsert_attendu',
  UpsertCommande = 'upsert_commande',
  DeleteStock = 'delete_stock',
  DeleteAttendu = 'delete_attendu',
  DeleteCommande = 'delete_commande',
  Import = 'import',
  Export = 'export',
}

export const INIT_APP_PERMISSIONS: AppPermission = {
  mission: {
    reception: true,
    putaway: true,
    reception_putaway: true,
    movement: true,
    regularization_plus: true,
    regularization_minus: true,
    preparation_completed: true,
    preparation_picking: true,
    loading: true,
    rap: true,
    re_cdn: true,
    return_to_stock: true,
    inventory: true,
  },
  management: {
    manual_location: true,
    affectation: true,
    forcing: true,
  },
}

export const APP_PERMISSION_LABEL = {
  reception: 'Réception a quai',
  putaway: 'Mise au stock',
  reception_putaway: 'Réception & Mise au stock',
  movement: 'Mouvements',
  regularization_plus: 'Régularisation +',
  regularization_minus: 'Régularisation -',
  preparation_completed: 'Préparation complète',
  preparation_picking: 'Préparation picking',
  loading: 'Chargement',
  rap: 'Réappro',
  re_cdn: 'ReCdn',
  return_to_stock: 'Remise au Stock',
  inventory: 'Inventaire',
  manual_location: 'Emplacement manuel',
  affectation: 'Affectation',
  forcing: 'Forçage',
}

export const missionHasLevel = (key: string) =>
  [
    'putaway',
    'reception_putaway',
    'movement',
    'rap',
    're_cdn',
    'return_to_stock',
  ].includes(key)

export const MIN_LEVEL = 0
export const MAX_LEVEL = 9

export const CANNOT_EDIT_ROLE_ERROR =
  'current user does not have permission to edit role'
